import {
  UPLOAD_FILE,
  UPLOAD_FILE_RESET,
  UPLOAD_FILE_SUCCESS,
} from "../action/actionType";
import { UPLOAD_FILE_FAILED } from "../action/actionType";

const initialState = {
  loading: false,
  data: null,
  error: null,
  status: false,
};

const uploadReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_FILE:
      return {
        ...state,
        loading: true,
      };
    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
        error: null,
        status: true,
      };
    case UPLOAD_FILE_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: payload,
        status: false,
      };
    case UPLOAD_FILE_RESET:
      return {
        ...state,
        loading: false,
        data: null,
        error: null,
        status: false,
      };
    default:
      return state;
  }
};

export default uploadReducer;
